<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <sc-flex-fitting-content [vertical]="true">
    <sc-master-detail [data]="visibleStationGroups" [selection]="selection" [newStyle]="true"
      (selectionChanged)="onSelectionChanged($event);" [saveAllMode]="true" (addEntry)="onAddEntry($event)"
      (deleteEntry)="onDeleteEntry($event)">
      <sc-padding [fitHeight]="true">
        <sc-scroll-pane>
          <form #form="ngForm" class="form no-field-space">
            <app-stationgroup-details [stationGroup]="stationGroup" *ngIf="stationSet == null">
            </app-stationgroup-details>
            <app-stationset [form]="form" [stationSet]="stationSet" [stationGroup]="stationGroup" class="main"
              *ngIf="stationSet != null">
            </app-stationset>
          </form>
        </sc-scroll-pane>
      </sc-padding>
      <ng-template masterDetailToolbar>
        <div class="message-container" *ngIf="form.dirty">
          <sc-padding>
            <div class="configChangedText">
              {{'The config has changed' | translate: ['tmc.stationgroup.configChanged',
              translationService.language]}}
            </div>
          </sc-padding>
          <div class="button-bar">
            <button mat-stroked-button type="button" class="" (click)="cancel()">{{'cancel' |
              translate: ['tmc.stationgroup.cancel', translationService.language]}}</button>
            <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
            <button mat-flat-button type="button" class="" [disabled]="isSaveDisabled()"
              (click)="saveChanges()">{{'save' | translate: ['tmc.stationgroup.save',
              translationService.language]}}</button>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
          </div>
        </div>
      </ng-template>
    </sc-master-detail>
  </sc-flex-fitting-content>
</sc-flex>